const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

// 🔹 Keep buttons synced with localStorage
const initButtons = () => {
  const wishlist = getWishlist();
  document.querySelectorAll(selectors.button).forEach(btn => {
    const handle = btn.dataset.productHandle;
    if (!handle) return;

    if (wishlist.includes(handle)) {
      btn.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      btn.classList.remove(BUTTON_ACTIVE_CLASS);
    }
  });
};

// 🔹 Initialize on load
document.addEventListener('DOMContentLoaded', () => {
  initGrid();
  initButtons(); // ✅ make sure buttons reflect wishlist state
});

document.addEventListener('shopify-wishlist:updated', () => {
  initGrid();
  initButtons(); // ✅ re-sync buttons after wishlist changes
});

document.addEventListener('product-recommendations:loaded', () => {
  initButtons(); // ✅ re-sync wishlist buttons when related products are injected (scripts in innerHTML don't run)
});

// 🔹 Event delegation for all wishlist buttons
document.addEventListener('click', function (e) {
  const btn = e.target.closest(selectors.button);
  if (!btn) return; // Not a wishlist button

  e.preventDefault();

  const productHandle = btn.dataset.productHandle;
  if (!productHandle) {
    console.error('[Shopify Wishlist] Missing data-product-handle');
    return;
  }

  updateWishlist(productHandle);

  // ✅ Instead of blind toggle, re-sync all buttons
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
});

const fetchProductData = async (handle) => {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Failed to fetch product ${handle}`);
    return await res.json();
  } catch (err) {
    console.error(`[Shopify Wishlist] Failed to fetch product: ${handle}`, err);
    return null;
  }
};

const buildProductCard = (product) => {
  if (!product) return '';

  return `
    <div class="wishlist-card">
      <a href="${product.url}">
        <img src="${product.images[0]}" alt="${product.title}" class="wishlist-card__image" />
      </a>
      <h3 class="wishlist-card__title">
        <a href="${product.url}">${product.title}</a>
      </h3>
      <p class="wishlist-card__price">
       $${(product.price / 100).toFixed(2)} ${Shopify.currency.active}
      </p>
      <button 
        class="wishlist-card__remove ${wishlistContains(product.handle) ? BUTTON_ACTIVE_CLASS : ''}" 
        button-wishlist 
        data-product-handle="${product.handle}">
        ${wishlistContains(product.handle) ? 'Remove' : 'Add'}
      </button>
    </div>
  `;
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();

  if (!wishlist.length) {
    grid.innerHTML = "<p class='wishlist-empty-p' >Add products to your wishlist to view them here.</p>";
    grid.classList.add(GRID_LOADED_CLASS);
    return;
  }

  const products = await Promise.all(wishlist.map(fetchProductData));
  const productCards = products.map(buildProductCard).join('');

  grid.innerHTML = productCards;
  grid.classList.add(GRID_LOADED_CLASS);

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist }
  });
  document.dispatchEvent(event);
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid);
  if (grid) setupGrid(grid);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || '';
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  if (index === -1) wishlist.push(handle);
  else wishlist.splice(index, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => getWishlist().includes(handle);

const resetWishlist = () => setWishlist([]);
